export var SwipeSpeed;
(function (SwipeSpeed) {
    SwipeSpeed["Slow"] = "drag";
    SwipeSpeed["Fast"] = "flick";
})(SwipeSpeed || (SwipeSpeed = {}));
export var SwipeDirection;
(function (SwipeDirection) {
    SwipeDirection[SwipeDirection["Up"] = 1] = "Up";
    SwipeDirection[SwipeDirection["Down"] = 2] = "Down";
    SwipeDirection[SwipeDirection["Left"] = 3] = "Left";
    SwipeDirection[SwipeDirection["Right"] = 4] = "Right";
    SwipeDirection[SwipeDirection["Horizontal"] = 5] = "Horizontal";
    SwipeDirection[SwipeDirection["Vertical"] = 6] = "Vertical";
})(SwipeDirection || (SwipeDirection = {}));
//# sourceMappingURL=swipe-constants.js.map